/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  EnableUserOptions,
  EnableUserStatus200,
  EnableUserStatus404,
  EnableUserStatus500,
} from '../types/EnableUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { enableUser } from '../clients/enableUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const enableUserMutationKey = () => [{ url: '/v1/user/:user_id/enable' }] as const

export function enableUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = enableUserMutationKey()
  return mutationOptions<
    EnableUserStatus200,
    ResponseErrorConfig<EnableUserStatus404 | EnableUserStatus500>,
    EnableUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return enableUser({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Enable a disabled user
 * {@link /v1/user/:user_id/enable}
 */
export function useEnableUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      EnableUserStatus200,
      ResponseErrorConfig<EnableUserStatus404 | EnableUserStatus500>,
      EnableUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? enableUserMutationKey()

  const baseOptions = enableUserMutationOptions(config) as UseMutationOptions<
    EnableUserStatus200,
    ResponseErrorConfig<EnableUserStatus404 | EnableUserStatus500>,
    EnableUserOptions,
    TContext
  >

  return useMutation<
    EnableUserStatus200,
    ResponseErrorConfig<EnableUserStatus404 | EnableUserStatus500>,
    EnableUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    EnableUserStatus200,
    ResponseErrorConfig<EnableUserStatus404 | EnableUserStatus500>,
    EnableUserOptions,
    TContext
  >
}
